import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { CardModule, IconModule, OutletModule, PromotionsModule } from '@spartacus/storefront';
import { KnBrCartSharedModule } from 'src/feature-libs/kn-br-cart/base/components/kn-br-cart-shared/kn-br-cart-shared.module';
import { AtgCheckoutReviewSubmitComponent } from './atg-checkout-review-submit/atg-checkout-review-submit.component';
import { FormsModule } from '@angular/forms';
import { AtgCartItemListModule } from '../cart-shared/atg-cart-item-list/atg-cart-item-list.module';




@NgModule({
  declarations: [AtgCheckoutReviewSubmitComponent],
  imports: [
    CommonModule,
    I18nModule,
    CardModule,
    KnBrCartSharedModule,
    UrlModule,
    RouterModule,
    PromotionsModule,
    IconModule,
    OutletModule,
    FormsModule,
    AtgCartItemListModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutReviewOrder: {
          component: () =>
            import('./atg-checkout-review-submit/atg-checkout-review-submit.component').then((c) => c.AtgCheckoutReviewSubmitComponent),
          guards: [CheckoutAuthGuard, CartNotEmptyGuard],
        },
      },
    }),
  ],
  exports: [AtgCheckoutReviewSubmitComponent],
})
export class AtgCheckoutReviewSubmitModule { }
